<ng-container *ngIf="hubspotFormBoxData$ | async as data">
    <h2 *ngIf="data.title" [innerHTML]="data.title"></h2>
    <p *ngIf="data.copytext && data.copytext.value" class="large" [innerHTML]="data.copytext.value"></p>
    <da-hubspot
        [hubspotId]="data.hubSpotFormID"
        [webinarId]="data.webinarID"
        [customFieldValues]="data.customHubspotFieldValues"
    ></da-hubspot>
</ng-container>
